module.exports = __webpack_public_path__ + "b5822f614d3c0395a3a37bf8a472394b.pdf";